export const ALERTS = 'alerts';
export const ALERTS_DARK = 'alerts_dark';
export const TF911_LIGHT = 'tf911_light';
export const TF911_DARK = 'tf911_dark';
export const RCS911_LIGHT = 'rcs_911_light';
export const RCS911_DARK = 'rcs_911_dark';
export const TCAPI_DARK = 'tcapi_dark';
export const TCAPI_LIGHT = 'tcapi_light';
export const INTERAGENCY_LIGHT = 'interagency_light';
export const INTERAGENCY_DARK = 'interagency_dark';
